import { render } from "./VcardButton.vue?vue&type=template&id=628923a0&scoped=true"
import script from "./VcardButton.vue?vue&type=script&lang=js"
export * from "./VcardButton.vue?vue&type=script&lang=js"

import "./VcardButton.vue?vue&type=style&index=0&id=628923a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628923a0"]])

export default __exports__